import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const FiltersShape = z.object({
  searchQuery: z.string().optional(),
});

const PaginationShape = z.object({
  page: z.number(),
  size: z.number(),
});

export const forwarderContract = c.router({
  retrieveForwarders: {
    method: 'POST',
    path: '/forwarder/retrieve-forwarders',
    body: z.object({
      criteria: z.object({
        filters: FiltersShape.optional(),
        pagination: PaginationShape.optional(),
      }),
    }),
    responses: {
      200: z.object({ forwarders: z.array(z.any()) }),
    },
  },
  retrieveForwardersMetadata: {
    method: 'POST',
    path: '/forwarder/retrieve-forwarders-metadata',
    body: z.object({
      filters: FiltersShape,
    }),
    responses: {
      200: z.object({ metadata: z.object({ total: z.number() }) }),
    },
  },
  retrieveForwarderDetails: {
    method: 'GET',
    path: '/forwarder/retrieve-forwarder-details/:id',
    pathParams: z.object({ id: z.string() }),
    responses: {
      200: z.object({ forwarder: z.any() }),
    },
  },
  updateForwarder: {
    method: 'PATCH',
    path: '/forwarder',
    body: z.object({ _id: z.string() }).and(z.record(z.string(), z.any())),
    responses: {
      200: z.object({ forwarder: z.any() }),
    },
  },
});
